import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SiteApiService, SocialLink } from './core/services/api.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
    menuOpen = false;
    socialLinks: SocialLink[] = [];

    constructor(
        private siteApi: SiteApiService,
        private router: Router
    ) { }

    ngOnInit(): void {
        this.getSocialLinks();
    }

    toggleMenu(): void {
        this.menuOpen = !this.menuOpen;
    }

    closeMenu(): void {
        this.menuOpen = false;
    }

    openAllProducts(event?: Event): void {
        if (event) {
            event.preventDefault();
        }

        this.closeMenu();

        this.router.navigate(['/products'], {
            queryParams: {
                category: 'all',
                reset: Date.now()
            }
        });
    }

    getSocialLinks(): void {
        this.siteApi.getSocialLinks().subscribe(
            (data: SocialLink[]) => {
                this.socialLinks = data || [];
            },
            (error) => {
                console.error('Social links could not be loaded', error);
            }
        );
    }

    getTarget(url: string): string {
        if (!url) {
            return '_self';
        }

        return url.indexOf('mailto:') === 0 ? '_self' : '_blank';
    }
}
